var render = function render(){var _vm=this,_c=_vm._self._c;return _c('select',{domProps:{"value":_vm.locationId},on:{"change":function($event){$event.preventDefault();return _vm.onChange.apply(null, arguments)}}},_vm._l((_vm.locations),function(location){return _c('option',{key:location.id,domProps:{"value":location.id}},[_vm._v(_vm._s(location.name))])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }